import { call, put, select } from 'redux-saga/effects';
import { urls } from '../../../common/urls';
import { getHttp, getHttpwithtoken, postHttpwithtoken } from '../../../common/ApiCall';
import {
  toursFailure,
  toursLoading,
  toursSuccess,
} from '../../ducks/ToursSlice';

// Tours Handler
export function* handlerToursReq(action: any): Generator<any, void, any> {
  try {
    yield put(toursLoading());
    const response: any = yield call(getHttpwithtoken, `${urls.baseURL}${urls.tours}`);
    
    if (response.success) {
      yield put(toursSuccess(response.data));
    } else {
      yield put(toursFailure(response.message || 'Failed to get tours'));
    }
  } catch (error: any) {
    yield put(toursFailure(error.message || 'Failed to get tours'));
  }
}
